import { InjectionToken } from '@angular/core';

export const VBR_NAVIGATOR_TOKEN = new InjectionToken<Navigator>('Navigator');
export const VBR_WINDOW = new InjectionToken<Window>('VBR_WINDOW');
